// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2NqOE","itemTitle":"ClientEmergencyInfo_itemTitle__10NmA","itemText":"ClientEmergencyInfo_itemText__1XDv6"};